import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ReportBuilder2Nro = lazy(() =>
  import("@scenes/ReportBuilder2").then((module) => ({
    default: module.ReportBuilder2,
  }))
);

export const reportBuilder2NRO: NavigationRoutingObject = {
  Component: ReportBuilder2Nro,
  componentFeatureFlippers: [],
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) => t("report-builder-sidebar-pill-menu-option", "Report Builder"),
  pageNameForTracking: () => "Report Builder",
  tag: "new",
  getDeveloperNavigationAllowed: ({ isImpersonating, hasPermission }) => {
    const userHasViewReportingPermission = hasPermission("appGroupOrAnyTeamInAppGroup", {
      permission: "viewReporting",
    });
    return isImpersonating || userHasViewReportingPermission;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("report-builder-alt-keyword-1", "custom report")],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  noKnockoutFallback: true,
};
